import React from 'react';
export function SystemPage() {
  return <div className="min-h-screen w-full bg-[#0B1120] text-slate-200 flex flex-col items-center justify-center p-4 sm:p-8 pt-20 sm:pt-8" data-id="element-703">
      <div className="w-full max-w-7xl" data-id="element-704">
        <div className="text-center mb-6 sm:mb-8" data-id="element-705">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4" data-id="element-706">
            The HIRE System
          </h1>
          <p className="text-base sm:text-xl text-slate-400" data-id="element-707">
            Visual breakdown of our recruiting system architecture
          </p>
        </div>

        <div className="w-full bg-slate-900/50 rounded-xl border border-slate-800 p-2 sm:p-4 shadow-2xl" data-id="element-708">
          <iframe style={{
          border: '1px solid rgba(0, 0, 0, 0.1)'
        }} width="100%" height="500" className="rounded-lg sm:h-[600px] md:h-[700px] lg:h-[800px]" src="https://embed.figma.com/board/VXiMkf6fYlJy2cjipBFyEw/The-HIRE-Advantage?node-id=0-1&embed-host=share" allowFullScreen data-id="element-709" />
        </div>
      </div>
    </div>;
}